var map = {
	"./ataTmpPat.store.ts": "5253",
	"./currentUser.store.ts": "78e2",
	"./formProvider.store.ts": "9121",
	"./navMenu.store.ts": "932d",
	"./recommendedDonors.store.ts": "4a52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "796c";